exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logo-banner{padding:10px 0 25px}.logo-banner__description{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:70px;margin-left:85px}@media screen and (min-width:768px){.logo-banner__description{height:100px;margin-left:130px}}.logo-banner__description a{padding:0}.logo-banner__avatar{float:left;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:70px;height:70px;border-radius:50%}.logo-banner__avatar a{display:block}@media screen and (min-width:768px){.logo-banner__avatar{width:100px;height:100px}}.logo-banner__avatar img{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/logo-banners/logo-banners.styl
// module id = 503
// module chunks = 0